import WelcomeSvg from '@/assets/WelcomeSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';
import { Form } from 'react-bootstrap';

export interface EmailFormProps {
  email: string;
  hasError: boolean;
  internalMode?: boolean;
  isLoading: boolean;
  onChangeEmail: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePassword?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  password?: string;
}

const EmailFormDesktop: React.FC<EmailFormProps> = ({
  email,
  hasError,
  internalMode = false,
  isLoading,
  onChangeEmail,
  onChangePassword,
  onSubmit,
  password = '',
}) => {
  const { t } = useTranslationWithPrefix('welcomePage');

  return (
    <div className="flex min-h-[calc(100vh-120px)] items-center">
      <div className="flex w-full gap-4">
        <div className="flex w-2/5 flex-col gap-3">
          <h1 className="text-[84px] font-black tracking-tight">
            {t('heading1')}
            <br />
            {t('heading2')}
          </h1>

          <div className="flex flex-col text-2xl font-semibold">
            <p className="text-primary m-0">{t('subheading1')}</p>
            <p className="m-0">{t('subheading2')}</p>
          </div>

          <div className="text-xl">
            <p>{t('description')}</p>
          </div>

          <Form className="text-left mt-2 flex max-w-md flex-col gap-3" onSubmit={onSubmit}>
            <Form.Control
              className="border border-gray-300 !placeholder:text-left"
              onChange={onChangeEmail}
              placeholder={t('emailPlaceholder')}
              type="email"
              value={email}
            />
            {internalMode && (
              <Form.Control
                className="border border-gray-300 !placeholder:text-left"
                onChange={onChangePassword}
                placeholder={t('passwordPlaceholder')}
                required
                type="password"
                value={password}
              />
            )}
            {hasError && <p className="text-sm text-danger">{t('error.wentWrong')}</p>}

            <ButtonWithLoading
              className="w-3/5 bg-primary py-3 text-white"
              isLoading={isLoading}
              type="submit"
            >
              {t('buttons.submit')}
            </ButtonWithLoading>

            <label className="flex items-start gap-2 text-sm font-light leading-snug text-gray-500">
              <Form.Check
                className="mt-0.5 shrink-0"
                disabled={isLoading}
                id="desktop-checkbox"
                required
                type="checkbox"
              />
              <span>{t('checkboxText')}</span>
            </label>
          </Form>
        </div>

        <div className="flex w-3/5 items-center justify-center ">
          <img
            alt="welcome-illustration"
            className="h-auto max-h-[900px] w-full object-contain translate-y-[-5%]"
            src={WelcomeSvg}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailFormDesktop;
